import { render } from "./vgpAvatar.vue?vue&type=template&id=06ecac9c&scoped=true"
import script from "./vgpAvatar.vue?vue&type=script&lang=js"
export * from "./vgpAvatar.vue?vue&type=script&lang=js"

import "./vgpAvatar.vue?vue&type=style&index=0&id=06ecac9c&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ecac9c"]])

export default __exports__